<template>
    <v-card flat rounded="lg" v-bind="{ loading }">
        <div class="px-4 py-2">
            <v-row class="ma-n2" align="center">
                <v-col cols="12" lg="auto" class="pa-2">
                    <v-card-title class="pa-0">
                        <span class="text-subtitle-2 font-weight-bold"> 집계 필터 </span>
                    </v-card-title>
                </v-col>
                <v-col cols="12" lg="" class="pa-2">
                    <v-card-text class="pa-0">
                        <v-row class="ma-n1" align="center">
                            <v-col cols="6" md="auto" lg="auto" class="pa-1">
                                <v-text-field
                                    v-model="searchDateValue[0]"
                                    v-bind="{
                                        ...attrs_input,
                                        type: 'date',
                                        label: '집계 시작일',
                                        style: 'min-width: 160px',
                                        loading,
                                    }"
                                    @input="emit"
                                />
                            </v-col>
                            <v-col cols="6" md="auto" lg="auto" class="pa-1">
                                <v-text-field
                                    v-model="searchDateValue[1]"
                                    v-bind="{
                                        ...attrs_input,
                                        type: 'date',
                                        label: '집계 종료일',
                                        style: 'min-width: 160px',
                                        loading,
                                    }"
                                    @input="emit"
                                />
                            </v-col>
                            <v-col cols="12" md="" lg="" class="pa-1">
                                <dates-toggle
                                    v-model="searchDateValue"
                                    v-bind="{
                                        loading,
                                    }"
                                    @input="emit"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import { attrs_input } from "@/assets/variables";

import DatesToggle from "@/components/console/dumb/dates-toggle.vue";

export default {
    components: {
        DatesToggle,
    },
    props: {
        value: { type: Array, default: () => [null, null] },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        searchDateValue: [null, null],

        attrs_input,
    }),
    methods: {
        sync() {
            this.searchDateValue = [
                //
                this.value[0]?.toDate?.() || null,
                this.value[1]?.toDate?.() || null,
            ];
        },
        emit() {
            this.$emit("input", [
                //
                this.searchDateValue[0] ? this.$dayjs(this.searchDateValue[0]).startOf("day").toISOString() : null,
                this.searchDateValue[1] ? this.$dayjs(this.searchDateValue[1]).endOf("day").toISOString() : null,
            ]);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>